import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { useDownloadFlyerModal } from './useDownloadFlyerModal';

type Context = 'starter_dashboard_task' | 'starter_dashboard_grow_petition';

export function useTriggerDownloadFlyerModal(context: Context): () => Promise<void> {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	const openDownloadFlyerModal = useDownloadFlyerModal();

	const triggerDownloadFlyerModal = useCallback(async () => {
		return openDownloadFlyerModal({
			petition,
			context,
		}).waitForResult();
	}, [openDownloadFlyerModal, petition, context]);

	return triggerDownloadFlyerModal;
}
